module.exports=function(scope){ return `{
    "data": {
        "sourceFaceMap": {
            "ageResult": 4,
            "livenessStatus": 0
        },
        "matchLevel": 7,
        "enrollmentIdentifier": "...",
        "targetFaceMap": {
            "glasses": false,
            "faceMapType": 1,
            "ageResult": 4,
            "creationStatus": 0,
            "creationStatusMessage": "The 2D Single Image FaceMap was created successfully.",
            "isLowQuality": false
        },
        "message": "The /match-3d-2d request was processed and the Match Level was 7",
        "tid": "..."
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The /match-3d-2d request was processed and the Match Level was 7"
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/compare3d2d.json.tpl